import(/* webpackMode: "eager", webpackExports: ["DateCards"] */ "/vercel/path0/components/company/DateCards/DateCards.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ImageHighlight"] */ "/vercel/path0/components/company/ImageHighlight/ImageHighlight.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AlternateSection"] */ "/vercel/path0/components/home/AlternateSection/AlternateSection.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/home/CardsSlider/CardsSlider/CardsSlider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["KeyFigures"] */ "/vercel/path0/components/home/keyFigures/KeyFigures.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ImageList"] */ "/vercel/path0/components/markets/ImageList/ImageList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/pages/impact/ImpactPage.preview.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/shared/DownloadEmail/DownloadEmail.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Gallery"] */ "/vercel/path0/components/shared/Gallery/Gallery.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Headline"] */ "/vercel/path0/components/shared/Headline/Headline.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HighlightedCardsSlider"] */ "/vercel/path0/components/shared/HighlightedCardsSlider/HighlightedCardsSlider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ImageSlider"] */ "/vercel/path0/components/shared/ImageSlider/ImageSlider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Properties"] */ "/vercel/path0/components/shared/Properties/Properties.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SingleImage"] */ "/vercel/path0/components/shared/SingleImage/SingleImage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SchemaSection"] */ "/vercel/path0/components/technology/SchemaSection/SchemaSection.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next-sanity/dist/visual-editing/VisualEditing.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
